module.exports = __webpack_public_path__ + "static/media/3_05.5da4af72.png";